import { render } from "./tw-grid-edit-ag.vue?vue&type=template&id=8e84b8e4"
import script from "./tw-grid-edit-ag.vue?vue&type=script&lang=js"
export * from "./tw-grid-edit-ag.vue?vue&type=script&lang=js"
script.render = render

export default script